// Ubicación en el repo: src/components/SuppliersList.jsx
// Administración de proveedores (Fase A del módulo de Inventario/
// Contabilidad, migración 0046, 24-ago-2026) — sub-pestaña de Catalog.jsx.
// Mismo patrón que CategoriesList.jsx/BrandsList.jsx.
import { useCallback, useEffect, useState } from 'react';
import { listAllSuppliersForAdmin, softDeleteSupplier, restoreSupplier } from '../lib/suppliers';
import SupplierFormModal from './SupplierFormModal';
import Spinner from './Spinner';

export default function SuppliersList({ actorId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [editTarget, setEditTarget] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      setItems(await listAllSuppliersForAdmin());
    } catch (err) {
      setError(err.message || 'No se pudo cargar los proveedores.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  async function handleToggleActive(item) {
    const action = item.deleted_at ? 'reactivar' : 'desactivar';
    const ok = window.confirm(`¿${action === 'reactivar' ? 'Reactivar' : 'Desactivar'} "${item.name}"?`);
    if (!ok) return;
    try {
      if (item.deleted_at) {
        await restoreSupplier(item.id);
      } else {
        await softDeleteSupplier(item.id, actorId);
      }
      refresh();
    } catch (err) {
      setError(err.message || `No se pudo ${action} el proveedor.`);
    }
  }

  return (
    <div>
      <div className="patients-page__toolbar">
        <h2 style={{ margin: 0 }}>Proveedores</h2>
        <div className="patients-page__toolbar-right">
          <button
            type="button"
            className="button-primary"
            onClick={() => {
              setEditTarget(null);
              setFormOpen(true);
            }}
          >
            + Nuevo proveedor
          </button>
        </div>
      </div>

      {error && <p className="auth-error">{error}</p>}

      <table className="patients-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>RUT</th>
            <th>Contacto</th>
            <th>Teléfono</th>
            <th>Correo</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={7}><Spinner inline /></td>
            </tr>
          ) : items.length === 0 ? (
            <tr>
              <td colSpan={7}>No hay proveedores registrados todavía.</td>
            </tr>
          ) : (
            items.map((s) => (
              <tr key={s.id}>
                <td>{s.name}</td>
                <td>{s.rut || '—'}</td>
                <td>{s.contact_name || '—'}</td>
                <td>{s.phone || '—'}</td>
                <td>{s.email || '—'}</td>
                <td>
                  {s.deleted_at ? (
                    <span className="badge badge-danger">Inactivo</span>
                  ) : (
                    <span className="badge badge-ok">Activo</span>
                  )}
                </td>
                <td className="actions-cell">
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => {
                      setEditTarget(s);
                      setFormOpen(true);
                    }}
                  >
                    Editar
                  </button>
                  <button
                    type="button"
                    className={`link-button ${s.deleted_at ? '' : 'link-button--danger'}`}
                    onClick={() => handleToggleActive(s)}
                  >
                    {s.deleted_at ? 'Reactivar' : 'Desactivar'}
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {formOpen && (
        <SupplierFormModal
          supplier={editTarget}
          onClose={() => {
            setFormOpen(false);
            setEditTarget(null);
          }}
          onSaved={() => {
            setFormOpen(false);
            setEditTarget(null);
            refresh();
          }}
        />
      )}
    </div>
  );
}
